import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import './Modal.scss'
const ModalWrapper = ({
    show,
    onHide,
    title,
    children,
    size,
    showFooter = true,
    onSubmit,
    saveButtonText = 'Save',
    cancelButtonText = 'Cancel',
    showCancel = false,
    className = '',
    dialogClassName,
    headerClass,
    bodyClass,
    showHeader = true,
    showRejectionCancelBtn = false,
    isDisableSaveBtn = false,
}) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size={size}
            centered
            dialogClassName={dialogClassName}
            className={className}
        >
            {showHeader && (
                <Modal.Header closeButton>
                    <Modal.Title className={headerClass}>{title}</Modal.Title>
                </Modal.Header>
            )}
            <Modal.Body className={bodyClass}>{children}</Modal.Body>
            {showFooter && (
                <Modal.Footer>
                    <div className='modal-actions'>
                        {showCancel && (
                            <Button
                                className='filters-btn'
                                onClick={onHide}
                                type='button'
                            >
                                {cancelButtonText}
                            </Button>
                        )}
                        <Button
                            className='modal-confirm-btn'
                            onClick={onSubmit}
                            type='submit'
                            disabled={isDisableSaveBtn}
                        >
                            {saveButtonText}
                        </Button>
                        {showRejectionCancelBtn && (
                            <Button className='filters-btn' variant='link' onClick={onHide}>
                                Not Now
                            </Button>
                        )}
                    </div>
                </Modal.Footer>
            )}
        </Modal>
    );
};

export default ModalWrapper;
